import React from 'react';

import './style.scss';

export default class ScrollDraggable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dragging: false,
    };
  }

  componentDidMount() {
    window.addEventListener('mouseup', this.handleMouseUp.bind(this));
    window.addEventListener('mousemove', this.handleMouseMove.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('mouseup', this.handleMouseUp.bind(this));
    window.removeEventListener('mousemove', this.handleMouseMove.bind(this));
  }

  handleMouseUp = e => {
    if (this.state.dragging) this.setState({ dragging: false });
  };

  handleMouseDown = e => {
    if (!this.state.dragging) {
      this.setState({ dragging: true });
      this.lastClientX = e.clientX;
      this.lastClientY = e.clientY;
      e.preventDefault();
    }
  };

  handleMouseMove = e => {
    if (this.state.dragging && this.container && this.container.scrollLeft !== undefined) {
      this.container.scrollLeft -= (-this.lastClientX + (this.lastClientX = e.clientX));
      this.container.scrollTop -= (-this.lastClientY + (this.lastClientY = e.clientY));
    }
  };

  render() {
    return (
      <div ref={ $el => this.container = $el } onMouseDown={ this.handleMouseDown } className='Scroll-draggable'>
        { this.props.children }
      </div>
    );
  }
}
